import React , {Component} from 'react';
import { GetFavouriteTour } from '../../../models/tour';
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';
import TourLeadPage from './tourLead';


class tourlead extends Component{
    constructor(){
        super();

        this.state={
            tourLeads:true,
            leadsList:[]
        }

    }

    HandleGetToursLeadsSuccessResponse = (res)=>{

        if(res !== false){

            console.log(res.data.interestedtourslist.rows);

            this.setState({
                tourLeads:false,
                leadsList:res.data.interestedtourslist.rows
            })

        }

        else{

            this.setState({
                tourLeads:false
            })
        }
    }

    render(){
        return(
            <div>
            <TourLeadPage {...this.props} mystate = {this.state}/>
            {((this.state.tourLeads === true) ? GetFavouriteTour(this.props.PnkStore, this.HandleGetToursLeadsSuccessResponse) : "")}
            </div>
        )
    }
}

export const TourLead = PnkConnect(tourlead , '');